import { BaseRequest } from "./baseRequest";

export class ConfCodeRequest extends BaseRequest {
  confSessionId?: number;
  configurationId?: number;
  codeFileId?: number;
  getStored?: boolean;
}